export var MobileEditorActions = {
    save: 'save',
    add: 'add',
    close: 'close'
};
export var MobileEditorActionsTypes = {
    image: 'image',
    normal: 'text',
    text: 'text'
};
//# sourceMappingURL=mobileEditorActions.js.mapexport var MobileEditorActions = {
    save: 'save',
    add: 'add',
    close: 'close'
};
export var MobileEditorActionsTypes = {
    image: 'image',
    normal: 'text',
    text: 'text'
};
//# sourceMappingURL=mobileEditorActions.js.map